import { render, staticRenderFns } from "./search-result-type-resource.vue?vue&type=template&id=125092a4&scoped=true&"
import script from "./search-result-type-resource.vue?vue&type=script&lang=js&"
export * from "./search-result-type-resource.vue?vue&type=script&lang=js&"
import style0 from "./search-result-type-resource.vue?vue&type=style&index=0&id=125092a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125092a4",
  null
  
)

export default component.exports